package ru.villawonka.app.presentation.model

import org.jetbrains.compose.resources.DrawableResource
import ru.villawonka.app.domain.model.CurrencyDomain
import ru.villawonka.app.presentation.screens.variantPicker.model.VariantPickerItemUIModel
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_currency_cny_24
import villawonka.composeapp.generated.resources.ic_currency_idr_24
import villawonka.composeapp.generated.resources.ic_currency_rub_24
import villawonka.composeapp.generated.resources.ic_currency_usd_24

sealed class CurrencyUIModel {
    
    abstract val icon: DrawableResource
    
    abstract val string: String
    
    abstract val code: String

    class Rub : CurrencyUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_currency_rub_24

        override val string: String = AppResources.strings.currencyRub

        override val code: String = "RUB"
    }

    class Usd : CurrencyUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_currency_usd_24

        override val string: String = AppResources.strings.currencyUsd

        override val code: String = "USD"
    }

    class Idr : CurrencyUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_currency_idr_24

        override val string: String = AppResources.strings.currencyIdr

        override val code: String = "IDR"
    }

    class Cny : CurrencyUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_currency_cny_24

        override val string: String = AppResources.strings.currencyCny

        override val code: String = "CNY"
    }
}

fun CurrencyDomain.toUIModel(): CurrencyUIModel = when(this) {
    CurrencyDomain.RUB -> CurrencyUIModel.Rub()
    CurrencyDomain.USD -> CurrencyUIModel.Usd()
    CurrencyDomain.IDR -> CurrencyUIModel.Idr()
    CurrencyDomain.CNY -> CurrencyUIModel.Cny()
}

fun CurrencyUIModel.toDomainModel(): CurrencyDomain = when(this) {
    is CurrencyUIModel.Rub -> CurrencyDomain.RUB
    is CurrencyUIModel.Usd -> CurrencyDomain.USD
    is CurrencyUIModel.Idr -> CurrencyDomain.IDR
    is CurrencyUIModel.Cny -> CurrencyDomain.CNY
}

fun CurrencyUIModel.toVariantPickerItemUIModel() = VariantPickerItemUIModel(
    title = this.string,
    subtitle = this.code
)

fun VariantPickerItemUIModel.toCurrencyUIModel(): CurrencyUIModel? =
    when (title) {
        AppResources.strings.currencyRub -> CurrencyUIModel.Rub()
        AppResources.strings.currencyUsd -> CurrencyUIModel.Usd()
        AppResources.strings.currencyIdr -> CurrencyUIModel.Idr()
        AppResources.strings.currencyCny -> CurrencyUIModel.Cny()
        else -> null
    }